import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { useStoreStatus } from "@/context/StoreContext";

export default function ClosingSoonBanner() {
  const { status, refresh } = useStoreStatus();
  const [now, setNow] = useState(Date.now());
  const target = status?.is_open ? status.closes_at_epoch_ms : null;
  useEffect(() => {
    if (!target) return undefined;
    const id = setInterval(() => setNow(Date.now()), 15_000);
    return () => clearInterval(id);
  }, [target]);
  useEffect(() => { if (target && now >= target) refresh(); }, [now, target, refresh]);
  if (!target) return null;
  const mins = Math.ceil((target - now) / 60000);
  if (mins > 30 || mins <= 0) return null;
  return (
    <div data-testid="closing-soon-banner" className="inline-flex items-center gap-2 bg-amber-50 border-2 border-amber-300 text-amber-800 rounded-full px-4 py-2 text-sm font-bold">
      <Clock size={15} /> Order before {status.closes_at} · {mins} min left
    </div>
  );
}
